import { Box, Switch, Typography } from '@mui/material';

const ChannelRow = ({
  title,
  description,
  checked,
  onChange,
  disabled,
  divider = true,
  children,
}) => (
  <Box
    sx={{
      px: 3,
      py: 2.5,
      borderBottom: divider ? '1px solid' : 'none',
      borderColor: 'divider',
      opacity: disabled ? 0.55 : 1,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: 700 }}>{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
      <Switch
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
        inputProps={{ 'aria-label': title }}
      />
    </Box>
    {checked && children ? <Box sx={{ mt: 2 }}>{children}</Box> : null}
  </Box>
);

export default ChannelRow;
